<template>
    <div class="bg-main" style="min-height: 100vh;">
        <tabs v-model="type" :tabList="typeList" @change="getOrderList"></tabs>
        <ul class="order-list bg-main px-bigger pt-normal">
            <orderBox class="mb-normal" 
                v-for="order in orderList" 
                :key="order.orderId"
                :dataSource="getBoxData(order)"
                @click.native="jumpDetail(order.orderId, order.shopId)">
                <flatCard v-for="goodsItem in order.goodsItems" 
                    :key="goodsItem.id"
                    :dataSource="getCardData(goodsItem)"
                    :isShowPrice="false">
                </flatCard>
            </orderBox>
            <h1 v-if="orderList.length === 0" class="center-title">没有订单数据哦！</h1>
        </ul>
    </div>
</template>

<script>
import tabs from '@common/tabs.vue';
import orderBox from '@common/orderBox';
import flatCard from '@common/card/flatCard.vue';
import http from '@/util/http';
export default {
    title() {
        return '微商城订单';
    },
    data() {
        return {
            type: Number(this.$route.query.orderType) || -99,
            typeList: [{
                name: '全部',
                id: -99
            }, {
                name: '待付款',
                id: -1
            }, {
                name: '待发货',
                id: 1
            }, {
                name: '已发货',
                id: 2
            }, {
                name: '待自提',
                id: 3
            }, {
                name: '已取消',
                id: 4
            }, {
                name: '已结束',
                id: 5
            }],
            orderList: []
        };
    },
    methods: {
        getBoxData(item) {
            return {
                orderTypes: 3,
                goodsNum: item.amount,
                amount: item.totalPrice,
                shopName: item.shopName,
                shopId: item.shopId,
                orderState: item.orderState
            };
        },
        getCardData(item) {
            return {
                price: item.price,
                imgUrl: item.imgUrl,
                name: item.name,
                num: item.amount
            };
        },
        getOrderList() {
            const params = {};
            if (this.type !== -99) {
                params.state = this.type;
            }
            http.get('/ecshopDirect/getEcshopOrderList', params).then(res => {
                this.orderList = res.data.list;
            });
        },
        jumpDetail(id, shopId) {
            this.$jump(`orderDetails/${id}?shopId=${shopId}`);
        }
    },
    components: {
        tabs,
        orderBox,
        flatCard
    },
    created() {
        if (sessionStorage.getItem('isFromIframe')) {
            this.typeList = [{
                name: '全部',
                id: -99
            }, {
                name: '待付款',
                id: -1
            }, {
                name: '待发货',
                id: 1
            }, {
                name: '待自提',
                id: 3
            }];
        }
        this.getOrderList();
    }
};
</script>